import React, {Component}   from 'react';
import {
  Panel,
  Modal,
  Button,
  OverlayTrigger,
  Tooltip
}                           from 'react-bootstrap';
import moment               from 'moment';
import axios              from "axios";
import {
  ToastContainer,
  toast
}                         from "react-toastify";
import isEqual            from "lodash.isequal";

import {
  IS_VALID,
  IS_UNDEFINED,
  IS_LENGTH_ZERO
}                           from "utils";

import saveTrail            from '../../utils/saveTrail';

import CrudComponent        from './../zynappse-crud'
import NotificationSchema   from './NotificationSchema'
import                           './style.less';
import FormContainer        from "./FormContainer";

const WEB_PATH = window.__APP_CONFIG__.webPath || 'http://localhost:3000';

class ScheduledNotification extends Component {
  constructor (props) {
    super(props);

    this.refreshTableReference;

    this.refreshTable = this.refreshTable.bind(this);
    this.saveNotification = this.saveNotification.bind(this);
    this.cancelPushNotification = this.cancelPushNotification.bind(this);
    this.sendNotification = this.sendNotification.bind(this);
    this.uploadUserCSVFile = this.uploadUserCSVFile.bind(this);
    this.loadOptions = this.loadOptions.bind(this);
    this.renderModalButton = this.renderModalButton.bind(this);
    this.accessible = this.accessible.bind(this);
  }

  refreshTable () {
    if (IS_VALID(this.refreshTableReference) && typeof this.refreshTableReference === 'function') {
      this.refreshTableReference();
    }
  }

  saveNotification () {
    let {
      ScheduledNotification,
      actions
    } = this.props;

    let {
      selectedData,
      formType,
      formId,

      sendMode,
      userType,
      cardType,
      device,
      screen,
      browser,

      specificUser,
      blacklistedUser,

      subject,
      url,
      message,
      isSendNow,
      scheduleDateTimeNotif
    } = ScheduledNotification;

    if (!IS_VALID(sendMode)) {
      toast.error("Send Mode is required.");
    } else if (!IS_VALID(userType)) {
      toast.error("User Type is required.");
    }  else if (!IS_VALID(device)) {
      toast.error("Device Type is required.");
    } else if (!IS_VALID(subject) || !IS_VALID(subject.trim())) {
      toast.error("Subject is required.");
    } else if (
      IS_VALID(browser) &&
      (!IS_VALID(url) || !IS_VALID(url.trim()))
    ) {
      toast.error("Url Link is required.");
    } else if (!IS_VALID(message) || !IS_VALID(message.trim())) {
      toast.error("Message is required.");
    } else if (
      !isSendNow &&
      !moment(scheduleDateTimeNotif, "MMM DD, YYYY hh:mm A", true).isValid()
    ) {
      toast.error("Please select a valid date and time.");
    } else if (
      !isSendNow &&
      moment(scheduleDateTimeNotif).isBefore(moment())
    ) {
      toast.error("Schedule should be greater than the date and time today.");
    } else {
      const getValue = (obj) => IS_VALID(obj) && IS_VALID(obj.value) ? obj.value : '';

      let data = {
        sendMode: getValue(sendMode),
        userType: getValue(userType),
        device: getValue(device),
        sendType: isSendNow ? "IMMEDIATE" : "SCHEDULED",
        type: "REGULAR",

        subject: subject.trim(),
        message: message.trim()
      };

      if (!isSendNow) {
        data.pushDateTime = moment(scheduleDateTimeNotif).toDate();
      } else if (IS_VALID(selectedData.get("pushDateTime"))) {
        selectedData.unset("pushDateTime");
      }

      if (IS_VALID(screen) && IS_VALID(screen.label)) {
        data.screen = screen.label;
      } else if (IS_VALID(selectedData.get("screen"))) {
        selectedData.unset("screen");
      }

      if (
        IS_VALID(cardType) &&
        Array.isArray(cardType) &&
        !IS_LENGTH_ZERO(cardType)
      ) {
        data.cardTypes = cardType.map(({ label }) => label);
      } else if (IS_VALID(selectedData.get("cardTypes"))) {
        selectedData.unset("cardTypes");
      }

      if (IS_VALID(browser)) {
        data.browser = getValue(browser);
      } else if (IS_VALID(selectedData.get("browser"))) {
        selectedData.unset("browser");
      }

      if (IS_VALID(url) && IS_VALID(url.trim())) {
        data.url = url.trim();
      } else if (IS_VALID(selectedData.get("url"))) {
        selectedData.unset("url");
      }

      if (
        IS_VALID(specificUser) &&
        Array.isArray(specificUser) &&
        !IS_LENGTH_ZERO(specificUser)
      ) {
        data.specificUsers = specificUser.map((item) => item.value);
      } else if (IS_VALID(selectedData.get("specificUsers"))) {
        selectedData.unset("specificUsers");
      }

      if (
        IS_VALID(blacklistedUser) &&
        Array.isArray(blacklistedUser) &&
        !IS_LENGTH_ZERO(blacklistedUser)
      ) {
        data.blacklistedUsers = blacklistedUser.map((item) => item.value);
      } else if (IS_VALID(selectedData.get("blacklistedUsers"))) {
        selectedData.unset("blacklistedUsers");
      }

      for (let key in data) {
        if (
          key === "specificUsers" ||
          key === "blacklistedUsers" ||
          key === "cardTypes"
        ) {
          if (!IS_VALID(selectedData.get(key)) || !isEqual(selectedData.get(key), data[key])) {
            selectedData.set(key, data[key]);
          }
        } else if (
          key === "pushDateTime"
        ) {
          if (!IS_VALID(selectedData.get(key)) || !moment(data[key]).isSame(moment(selectedData.get(key)))) {
            selectedData.set(key, data[key]);
          }
        } else {
          if (
            !IS_VALID(selectedData.get(key)) ||
            selectedData.get(key) !== data[key]
          ) {
            selectedData.set(key, data[key]);
          }
        }
      }

      let dirtyKeys = selectedData.dirtyKeys();

      let changesObject = {
        objectId: selectedData.id
      };

      for (let key of dirtyKeys) {
        if (
          key === "specificUsers" ||
          key === "blacklistedUsers" ||
          key === "cardTypes"
        ) {
          changesObject[key] = IS_VALID(selectedData.get(key)) ? selectedData.get(key).join(", ") : "unset";
        } else if (
          key === "pushDateTime"
        ) {
          changesObject[key] = IS_VALID(selectedData.get(key)) ? moment(selectedData.get(key)).format("MMM DD, YYYY hh:mm A") : "unset";
        } else {
          changesObject[key] = IS_VALID(selectedData.get(key)) ? selectedData.get(key) : "unset";
        }
      }

      actions.setValue({ isLoadingAction: true });

      selectedData.save(null, { useMasterKey: false })
      .then((selectedData) => {
        actions.setValue({
          isLoadingAction: false,
          showModal: false
        });

        this.refreshTable();

        saveTrail(
          formType,
          changesObject
        );
      })
      .catch((err) => {
        console.log("saveNotification error: ", err);

        actions.setValue({
          isLoadingAction: false,
          showModal: false
        });

        this.refreshTable();
      });
    }
  }

  cancelPushNotification () {
    let {
      ScheduledNotification,
      actions
    } = this.props;

    let {
      selectedData
    } = ScheduledNotification;

    selectedData.set("status", "INACTIVE");

    actions.setValue({ isLoadingAction: true });

    selectedData.save(null, { useMasterKey: false })
    .then((data) => {
      actions.setValue({
        isLoadingAction: false,
        showModal: false
      });

      this.refreshTable();

      saveTrail(
        "CANCEL NOTIFICATION",
        {
          objectId: data.id,
          subject: selectedData.get("subject"),
          status: "INACTIVE"
        }
      );
    })
    .catch((err) => {
      console.log("cancelPushNotification error: ", err);

      actions.setValue({
        isLoadingAction: false,
        showModal: false
      });

      this.refreshTable();
    });
  }

  sendNotification (callback) {
    let {
      ScheduledNotification,
      actions
    } = this.props;

    let {
      selectedData
    } = ScheduledNotification;

    selectedData.set("status", "ACTIVE");

    actions.setValue({ isLoadingAction: true });

    let changesObject = {};

    let keys = [
      "type",
      "sendMode",
      "userType",
      "cardTypes",
      "device",
      "screen",
      "browser",

      "subject",
      "url",
      "message",

      "sendType",
      "pushDateTime",

      "specificUsers",
      "blacklistedUsers",
      "User",

      "status"
    ];

    for (let key of keys) {
      if (key === "User" || key === "Sender") {
        changesObject[key] = IS_VALID(selectedData.get(key)) && (selectedData.get(key).get("name")) ? selectedData.get(key).get("name") : selectedData.get(key).get("username");
      } else if (key === "specificUsers" || key === "blacklistedUsers") {
        changesObject[key] = IS_VALID(selectedData.get(key)) ? selectedData.get(key).join(", ") : "";
      } else if (key === "pushDateTime" || key === "dateApproved") {
        changesObject[key] = IS_VALID(selectedData.get(key)) ? moment(selectedData.get(key)).format() : "";
      } else if (key !== "ACL") {
        changesObject[key] = IS_VALID(selectedData.get(key)) ? selectedData.get(key) : "";
      }
    }
    
    selectedData.save(null, { useMasterKey: false })
    .then((data) => {
      actions.setValue(
        {
          isLoadingAction: false,
          showModal: false
        }
      );

      callback();

      this.refreshTable();

      saveTrail(
        "SEND NOTIFICATION",
        changesObject
      );
    })
    .catch((err) => {
      console.log("sendNotification error: ", err);

      selectedData.revert();

      actions.setValue(
        {
          isLoadingAction: false
        }
      );

      callback();
    });
  }

  uploadUserCSVFile (csvFile, stateName) {
    let {
      ScheduledNotification,
      actions
    } = this.props;

    let usersState = ScheduledNotification[stateName];

    actions.setValue({ isUploadingCSVFile: true });

    let fd = new FormData();

    fd.append("csvFile", csvFile);

    axios.post(
      WEB_PATH + "/MemberDetail/upload",
			fd
    )
    .then((res) => {
      let {
				data
			} = res;

      let updatedUsersState = [...usersState];

      for (let item of data) {
        if (updatedUsersState.map((item) => item.value).indexOf(item.value) === -1) {
          updatedUsersState.push({
            label: `${IS_VALID(item.memberId) ? item.memberId : ""} ${IS_VALID(item.name) ? item.name : ""}`,
            value: item.memberId
          });
        }
      }

      actions.setValue(
        {
          isUploadingCSVFile: false,
          [stateName]: updatedUsersState
        }
      );
    })
    .catch((err) => {
      console.log("uploadUserCSVFile error: ", err);

      actions.setValue({ isUploadingCSVFile: false });
    });
  }

  loadOptions (input, cb, className, columnName, reduxCol) {
    let query = new Parse.Query(className);

    if (typeof columnName === "string") {
      query.matches(columnName, ".*" + input + ".*", "i");
    } else {
      let queryArray = [];
      for (let column of columnName) {
        let query2 = new Parse.Query(className);
        query2.matches(column, ".*" + input + ".*", "i");
        queryArray.push(query2);
      }
      query = Parse.Query.or(...queryArray);
    }

    switch (className) {
      case "CardType":
        query.ascending("name");
        break;
      case "Screen":
        query.ascending("pageName");
        break;
    }

    query.limit(20);

    query.find()
    .then((data) => {
      const label = obj => {
        if (typeof columnName === "string") {
          return !IS_UNDEFINED(obj.get(columnName)) ? obj.get(columnName) : "";
        } else {
          return columnName
            .map(column =>
              !IS_UNDEFINED(obj.get(column)) ? obj.get(column) : ""
            )
            .join(" ");
        }
      };

      cb(
        null,
        {
          options: data.map((item) => ({
            label: label(item),
            value: className === "MemberDetail" ? item.get("memberId") : item.id
          }))
        }
      );
    })
    .catch((err) => {
      console.log("loadOptions error: ", err);
      cb(null, { options: [] });
    })
  }

  renderModalButton () {
    let {
      ScheduledNotification,
      actions
    } = this.props;

    let {
      isLoadingAction,
      formType
    } = ScheduledNotification;

    let buttons = [],
        buttonClose = (
          <Button
            disabled={isLoadingAction}
            onClick={() => {
              if (!isLoadingAction) {
                actions.setValue({ showModal: false });
              }
            }}
            >
            CLOSE
          </Button>
        ),
        button = (title = "CANCEL NOTIFICATION", action = this.cancelPushNotification ) => (
          <Button
            bsStyle="primary"
            disabled={isLoadingAction}
            onClick={() => action()}
            >
            {title}
          </Button>
        );

    switch (formType.toUpperCase()) {
      case "UPDATE":
        buttons.push(button("UPDATE", this.saveNotification));
        buttons.push(buttonClose);
        break;
      case "CANCEL":
        buttons.push(button());
        buttons.push(buttonClose);
        break;
      default:
        buttons.push(buttonClose);
    }

    return buttons;
  }

  accessible (actionType) {
    let {
			access
		} = this.props.accessjson;

    if (access.length !== 0) {
			var currentPath = window.location.pathname,
					index = access.map((module) => module.route.toUpperCase()).indexOf(currentPath.toUpperCase()),
					actions = [];

			if (access[index]) {
				actions = access[index].actions
			}

			if (actions.length != 0) {
				if (actions.indexOf(actionType.toUpperCase()) === -1) {
					return 'none';
				} else {
					return '';
				}
			} else {
	      return 'none';
	    }
		} else {
			return 'none';
		}
  }

  render() {
    let {
      ScheduledNotification,
      accessjson,
      actions
    } = this.props;

    let {
      showModal,
      isLoadingAction,
      formType,
      formTitle
    } = ScheduledNotification;

    let {
			access
		} = accessjson;

    NotificationSchema.classNameLabel = "Scheduled Notification";

    var scheduledNotification = [
      { method: 'equalTo', column: 'sendType', value: "SCHEDULED" },
      { method: 'exists', column: 'pushDateTime' },
      { method: 'descending', column: 'createdAt' }
    ];

    let crudProps = {
      schema: NotificationSchema,
      moduleQuery: scheduledNotification,
      refreshTable: (refreshTable) => { this.refreshTableReference = refreshTable; },
      access: access,
      saveTrail: saveTrail,
      customView: (obj) => {
        actions.setValue(
          {
            showModal: true,
            formType: "VIEW",
            formTitle: "VIEW SCHEDULED NOTIFICATION",
            formId: obj.id,
            selectedData: obj
          }
        );
      },
      customUpdate: (obj) => {
        let stateToUpdate = {
          showModal: true,
          formType: "UPDATE",
          formTitle: "UPDATE SCHEDULED NOTIFICATION",
          formId: obj.id,
          selectedData: obj
        };

        if (IS_VALID(obj.get("sendMode"))) {
          stateToUpdate.sendMode = {
            value: obj.get("sendMode"),
            label: obj.get("sendMode")
          };
        }

        if (IS_VALID(obj.get("userType"))) {
          stateToUpdate.userType = {
            value: obj.get("userType"),
            label: obj.get("userType")
          };
        }

        if (IS_VALID(obj.get("cardTypes"))) {
          stateToUpdate.cardType = obj.get("cardTypes").map((cardType) => ({
            value: cardType,
            label: cardType
          }));
        }

        if (IS_VALID(obj.get("device"))) {
          stateToUpdate.device = {
            value: obj.get("device"),
            label: obj.get("device")
          };
        }

        if (IS_VALID(obj.get("screen"))) {
          stateToUpdate.screen = {
            value: obj.get("screen"),
            label: obj.get("screen")
          };
        }

        if (IS_VALID(obj.get("browser"))) {
          stateToUpdate.browser = {
            value: obj.get("browser"),
            label: obj.get("browser")
          };
        }

        if (IS_VALID(obj.get("subject"))) {
          stateToUpdate.subject = obj.get("subject");
        }

        if (IS_VALID(obj.get("url"))) {
          stateToUpdate.url = obj.get("url");
        }

        if (IS_VALID(obj.get("message"))) {
          stateToUpdate.message = obj.get("message");
        }

        if (IS_VALID(obj.get("pushDateTime"))) {
          stateToUpdate.scheduleDateTimeNotif = moment(obj.get("pushDateTime"));
        }

        actions.setValue(stateToUpdate);
      },
      customItems: [
        {
          columnName: "subject",
          render: ({ value }) => {
            let renderValue = "";

            if (IS_VALID(value)) {
              renderValue = value.substr(0, 100).trim() + (value.length <= 100 ? "" : "...");
            }

            return renderValue;
          }
        },
        {
          columnName: "status",
          render: ({value, column, getTableData, object}) => {
            let renderValue = value;

            if (IS_VALID(value)) {
              if (value.toUpperCase() === "ACTIVE") {
                renderValue = <span style={{ color: "green" }}>{value}</span>;
              } else if (value.toUpperCase() === "INACTIVE") {
                renderValue = <span style={{ color: "gray" }}>{value}</span>;
              }
            }

            return renderValue;
          }
        }
      ],
      customAction: ({ object, buttonView, buttonUpdate, buttonDelete }) => {
        let status = object.get("status");

        let button = (
          popupTitle = "Cancel",
          iconName = "fa-times",
          iconStyle = {},
          action = () => {
            actions.setValue({
              showModal: true,
              formType: "CANCEL",
              formTitle: "CANCEL SCHEDULED NOTIFICATION",
              formId: object.id,
              selectedData: object
            });
          }
        ) => (
          <OverlayTrigger
            placement="top"
            overlay={
              <Tooltip id={popupTitle.toLowerCase()}>
                {popupTitle}
              </Tooltip>
            }
            >
            <a
              style={iconStyle}
              className={`fa ${iconName} fa-lg`}
              href="javascript:void(0)"
              onClick={action}
              />
          </OverlayTrigger>
        );

        let buttons = [
          buttonView
        ];

        if (
          !IS_UNDEFINED(status) &&
          status.toUpperCase() === "INACTIVE"
        ) {
          buttons.push(buttonUpdate);

          if (
            this.accessible("SEND NOTIFICATION") === ""
          ) {
            buttons.push(
              button(
                "Send Notification",
                "fa-chevron-circle-right",
                { color: "green" },
                () => {
                  actions.setValue({
                    showModal: true,
                    formType: "VIEW",
                    formTitle: "VIEW SCHEDULED NOTIFICATION",
                    formId: object.id,
                    selectedData: object
                  })
                }
              )
            );
          }
        }

        if (
          (
            IS_UNDEFINED(status) ||
            status.toUpperCase() === "ACTIVE"
          ) &&
          this.accessible("CANCEL NOTIFICATION") === ""
        ) {
          buttons.push(button());
        }

        return (
          <span>
            {buttons}
          </span>
        );
      }
    };

    let formContainerProps = {
      ...this.props,
      sendNotification: this.sendNotification,
      uploadUserCSVFile: this.uploadUserCSVFile,
      loadOptions: this.loadOptions,
      accessible: this.accessible
    };

    return (
			<Panel>
				<Panel.Heading style={{
					backgroundColor: '#D1282F',
					color: 'white'
				}}>
					<h4>{NotificationSchema.classNameLabel.toUpperCase()}</h4>
				</Panel.Heading>
				<Panel.Body>
					<CrudComponent {...crudProps}/>
				</Panel.Body>
        <Modal
          bsSize={formType.toUpperCase() === "UPDATE" ? "large" : null}
          show={showModal}
          onHide={() => {
            if (!isLoadingAction) {
              actions.setValue({ showModal: false });
            }
          }}
          >
          <Modal.Header closeButton>
            <Modal.Title>{(IS_VALID(formTitle) ? formTitle : formType).toUpperCase()}</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <FormContainer {...formContainerProps}/>
          </Modal.Body>
          <Modal.Footer>
            {this.renderModalButton()}
          </Modal.Footer>
        </Modal>
        <ToastContainer/>
			</Panel>
		);
  }
}

import {connect}            from 'react-redux';
import {bindActionCreators} from 'redux';
import {generics}           from 'actions';
import {
  SCHEDULED_NOTIFICATION
}                           from "actions/const";

function mapStateToProps(state) {
	var {
    ScheduledNotification,
		accessjson
	} = state;

	return {
    ScheduledNotification,
		accessjson
	};
}

function mapDispatchToProps(dispatch) {
  const actions = {
    setValue: (keyValueObject, actionType = SCHEDULED_NOTIFICATION) => generics.setValue(actionType, keyValueObject)
  };

  return {
    actions: bindActionCreators(actions, dispatch)
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(ScheduledNotification);



// WEBPACK FOOTER //
// ./components/ScheduledNotification/index.js